import type { IMasterDataDeductionTypeRepository } from "@src/domain/repositories/masterData";
import type { DeductionTypesLookupItem } from "@src/domain/dto/masterData";

export class GetDeductionTypesLookupUseCase {
  private readonly repository: IMasterDataDeductionTypeRepository;

  constructor(repository: IMasterDataDeductionTypeRepository) {
    this.repository = repository;
  }

  execute(): Promise<{ items: DeductionTypesLookupItem[]; count: number }> {
    return this.repository.getDeductionTypesLookup();
  }
}
